import { FilterType, } from '../../common/components/filter-options';
import { API } from 'vendor/api';
function getLocationSearchByString(location) {
    return location.name.toLowerCase();
}
function getRoomSearchByString(room) {
    return `${room.name}$$${room.displayName}$$/${room.slug}`.toLowerCase();
}
function getProviderSearchByString(provider) {
    return `${provider.title} ${provider.firstName} ${provider.lastName}$$${provider.title} ${provider.lastName} ${provider.firstName}$$${provider.displayName}$$${provider.email}`.toLowerCase();
}
export default async function getFilterOptions(institutionId, providerFullNameBuilder) {
    return API.institution
        .getAnalyticsFilterOptions({ institutionId })
        .then(({ providers, rooms, locations }) => {
        const locationsOptions = Boolean(locations)
            ? locations.map((location) => ({
                reactKey: `location-${location.id}`,
                type: FilterType.Location,
                searchByString: getLocationSearchByString(location),
                id: location.id,
                optionLabel: `${location.name}`,
                sortByString: location.name,
                isDefault: location.isDefault,
            }))
            : [];
        const options = [
            ...rooms.map((room) => ({
                reactKey: `room-${room.id}`,
                type: FilterType.Room,
                searchByString: getRoomSearchByString(room),
                id: room.id,
                optionLabel: `/${room.slug}`,
                selectedOptionLabel: `/${room.slug}${Boolean(room.isPersonal) ? '' : ' (shared room)'}`,
                sortByString: room.slug,
            })),
            ...providers.map((provider) => ({
                reactKey: `provider-${provider.id}`,
                type: FilterType.Provider,
                searchByString: getProviderSearchByString(provider),
                id: provider.id,
                optionLabel: providerFullNameBuilder(provider),
                sortByString: Boolean(provider.lastName)
                    ? `${provider.lastName} ${provider.firstName}`
                    : providerFullNameBuilder(provider),
                imageUrl: provider.userProfilePictureUrl,
            })),
            ...locationsOptions,
        ];
        return options.sort((option1, option2) => option1.sortByString.localeCompare(option2.sortByString));
    });
}
